import { deleteApi, getApi, postApi, putApi } from "./general.service";

export const getTopics = async (data) => {
    return await getApi("/admin/topic", data);
};

export const deleteTopic = async (topic) => {
    return await deleteApi(`/admin/topic?_id=${topic._id}`);
};

export const getTopicById = async (topicId) => {
    // Use admin endpoint (isBackoffice=true) for edit form: title/description as arrays, topicImageUrl, catalogItems enriched
    return await getApi(`/admin/topic/${topicId}`);
};

export const createTopic = async (topicData) => {
    const payload = {
        ...topicData,
        startDate: topicData.startDate instanceof Date ? topicData.startDate.toISOString() : topicData.startDate,
        endDate: topicData.endDate instanceof Date ? topicData.endDate.toISOString() : topicData.endDate,
    };
    delete payload.catalogItemRefs; // solo catalogItems (array de sourceIds)
    return await postApi("/admin/topic", payload, {
        headers: {
            'Content-Type': 'application/json',
        }
    });
};

export const updateTopic = async (topicData) => {
    const payload = {
        ...topicData,
        startDate: topicData.startDate instanceof Date ? topicData.startDate.toISOString() : topicData.startDate,
        endDate: topicData.endDate instanceof Date ? topicData.endDate.toISOString() : topicData.endDate,
    };
    delete payload.catalogItemRefs; // solo catalogItems (array de sourceIds)
    return await putApi("/admin/topic", payload);
};